import React from 'react';
import PropTypes from 'prop-types';
import { Link, withRouter } from 'react-router-dom';

import classes from './WireDataItems.css';
import ListItem from '../../UI/ListItems/SingleRowListItem/ListItem';

const createWireURIElement = wire => {
  let wireURIelement = wire;
  wireURIelement = wireURIelement.replace(/\//g, '-');
  wireURIelement = wireURIelement.replace(/\s/g, '');
  return `/${wireURIelement}`;
};

const wireDataItems = props => {
  const { country } = props;
  const wireData = require(`../../../assets/data/AppData/${country}/WireData/MaxConductorsNumber.json`);

  const wireItemsList = Object.keys(wireData);
  const wireItems = [];

  Object.keys(wireItemsList).forEach(i => {
    const item = (
      <Link
        key={wireItemsList[i]}
        to={props.match.path + createWireURIElement(wireItemsList[i])}
        style={{ textDecoration: 'none' }}
      >
        <ListItem title={wireItemsList[i]} direction="next" />
      </Link>
    );

    wireItems.push(item);
  });

  wireItems.reduce((arr, el) => arr.concat(el), []);

  return (
    <div className={classes.WireDataItemsWrapper}>
      <div className={classes.WireDataItems}>{wireItems}</div>
    </div>
  );
};

wireDataItems.propTypes = {
  country: PropTypes.string.isRequired
};

export default withRouter(wireDataItems);
